"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBErrorPage", {
  enumerable: true,
  get: function get() {
    return _SVBErrorPage.default;
  }
});
var _SVBErrorPage = _interopRequireDefault(require("./src/SVBErrorPage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }